import CatalogTitle from './component';

export default CatalogTitle;
